import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="mt-4 text-center text-sm text-gray-500">
      <a
        href="https://vayana.com/privacy-policy/#:~:text=Vayana%20Network%20will%20not%20sell,the%20processing%20of%20the%20transaction"
        target="_blank"
        rel="noopener noreferrer"
        className="mx-2 text-indigo-600 hover:text-indigo-500"
      >
        Privacy Policy
      </a>
      <span className="text-gray-300">|</span>
      <a
        href="/Grievance Redressal & Dispute Resolution.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="mx-2 text-indigo-600 hover:text-indigo-500"
      >
        Grievance Redressal Policy
      </a>

      <span className="text-gray-300">|</span>
      <a
        href="/Terms-and-Conditions-V2P.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="mx-2 text-indigo-600 hover:text-indigo-500"
      >
        Terms and Conditions
      </a>
      <span className="text-gray-300">|</span>
      <a
        href="/ISMS Vayana - Onboarding Policy.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="mx-2 text-indigo-600 hover:text-indigo-500"
      >
        Merchant Onboarding Policy
      </a>
    </footer>
  );
};

export default Footer;
